import { MappedClass, MappedProperty, MappedPropertyDate } from '@h5s/util-object';

import { DateTime } from 'luxon';

@MappedClass()
export class CustomerInfoWithoutInvoicedCityTax {
  @MappedPropertyDate()
  checkInDate: DateTime;

  @MappedPropertyDate()
  checkOutDate: DateTime;

  @MappedProperty()
  name: string | null;

  @MappedProperty()
  reservationId: number;

  @MappedProperty()
  roomNumber: string;

  @MappedProperty()
  surname: string;

  constructor(init?: Partial<CustomerInfoWithoutInvoicedCityTax>) {
    Object.assign(this, init);
  }
}
